/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Center,
  CentersManyResponse,
  CreateCenterDto,
  UpdateCenterDto,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Centers<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags centers
   * @name CreateCenter
   * @summary Creates a center
   * @request POST:/centers
   * @secure
   */
  createCenter = (data: CreateCenterDto, params: RequestParams = {}) =>
    this.request<Center, void>({
      path: `/centers`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags centers
   * @name FindCenters
   * @summary Gets all centers
   * @request GET:/centers
   * @secure
   */
  findCenters = (params: RequestParams = {}) =>
    this.request<CentersManyResponse, void>({
      path: `/centers`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags centers
   * @name FindCenterById
   * @summary Finds a center
   * @request GET:/centers/{centerId}
   * @secure
   */
  findCenterById = (centerId?: string, params: RequestParams = {}) =>
    this.request<Center, void>({
      path: `/centers/${centerId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags centers
   * @name UpdateCenter
   * @summary Updates a center
   * @request PUT:/centers/{centerId}
   * @secure
   */
  updateCenter = (
    centerId: string,
    data: UpdateCenterDto,
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/centers/${centerId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags centers
   * @name ArchiveCenter
   * @summary Deletes a center
   * @request DELETE:/centers/{centerId}
   * @secure
   */
  archiveCenter = (centerId: string, params: RequestParams = {}) =>
    this.request<void, void>({
      path: `/centers/${centerId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
}
